import {ApolloClient} from "@apollo/client";

import {
    GetAssistantConversationQuery,
    GetAssistantConversationQueryVariables,
    GetAssistantConversationDocument,
    SenderRole,
} from "../../../../types/generated";
import {SocketMessage} from "../../types";

type AddNewMessageToCacheProps = {
    client: ApolloClient<object>;
    socketMessage: SocketMessage;
    conversationId: string;
    universityId: string;
    token?: string;
};

export function addNewMessageToCache({
    client,
    socketMessage,
    conversationId,
    universityId,
    token,
}: AddNewMessageToCacheProps) {
    const result = client.readQuery<
        GetAssistantConversationQuery,
        GetAssistantConversationQueryVariables
    >({
        query: GetAssistantConversationDocument,
        variables: {
            id: conversationId,
            universityId,
            token,
        },
    });

    if (!result?.getAssistantConversation) {
        console.error("Couldn't read from cache");
        return false;
    }

    if (
        result.getAssistantConversation.messages.find((message) => message.id === socketMessage.id)
    ) {
        return false;
    }

    const metadata = !socketMessage.metadata
        ? null
        : {
              ambassadorProfile: socketMessage.metadata.ambassadorProfile ?? null,
              staffProfile: socketMessage.metadata.staffProfile ?? null,
          };
    const messages = [
        ...(result.getAssistantConversation?.messages || []),
        {
            __typename: "AssistantConversationMessage" as const,
            id: socketMessage.id,
            sender: SenderRole.Assistant,
            createdAt: socketMessage.createdAt,
            message: socketMessage.message,
            metadata: metadata,
            feedback: null,
            universityId,
        },
    ];

    client.writeQuery<GetAssistantConversationQuery, GetAssistantConversationQueryVariables>({
        query: GetAssistantConversationDocument,
        variables: {
            id: conversationId,
            universityId,
            token,
        },
        data: {
            ...result,
            getAssistantConversation: {
                ...result.getAssistantConversation,
                messages,
            },
        },
    });
    return true;
}
